import React, { useEffect, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import { useLocation, useNavigate } from 'react-router-dom';
import { alphaNumeric, isValidEmail, onlyNumeric } from '../../../components/commonClass/CommonValidation';
import Select from 'react-select';
import { loaderActions } from '../../../_actions/loader.actions';
import { useDispatch } from 'react-redux';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage, SetLocalStorage, UpdateStatusLocalStorage } from '../../../components/commonClass/Session';
import Switch from 'react-switch';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { Modal } from '../../../_helpers/Modal';
import { Oval } from 'react-loader-spinner';


const CorporateBasicInfo = (props: any) => {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, setCorporateId, CorporateId, setWarningMessages, domainWiseDisable, datalist, setCorporateStatusId } = props
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState<any>({})
  const [dropdownList, setDropDownList] = useState<any>([])
  const [editcleardisabled, setEditClearDisabled] = useState(true)
  const [isReady, setIsReady] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [activeId, setActiveId] = useState(true);
  const [formValue, setFormValue] = useState({
    CorporateId: 0,
    NameOfCompany: '',
    PointOfContact: '',
    POCDesignation: '',
    EmailId: '',
    PhoneNo: '',
    AlternatePhoneNo: '',
    Street: '',
    CityId: 0,
    StateId: 0,
    PINCode: '',
    CountryId: 0,
    RegistrationNo: '',
    GSTNo: '',
    IsActive: true,
    UserId: 0
  })

  const onChange = (name: any, val: any) => {
    setFormErrors({});
    setIsSaved((save: any) => ({ ...save, BasicInfo: false }))
    setEditClearDisabled(false);
    if (name === 'CityId') {
      setFormValue((form: any) => ({ ...form, [name]: val?.value, StateId: val?.StateId, CountryId: val?.CountryId }))
    }
    else {
      setFormValue((form: any) => ({ ...form, [name]: val }))
    }
  }

  const handleisActive = (e: boolean) => {
    if (location?.state?.viewtype !== 'Update') {
      formValue.IsActive = e
      setActiveId(!activeId)
      setFormErrors(null);
    }
    else {
      setModalShow(true);
    }
  }
  const handleConfirmation = (e: any) => {
    //setYesNoConfirm(e)
    if (e === true) {
      formValue.IsActive = !activeId
      setActiveId(!activeId)
      setEditClearDisabled(false);
      setFormErrors(null);
    }
    setModalShow(false);
  }

  const getcountrystatecity = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData('/midoffice/v1/getcountrystatecity')
      if (list?.status) {
        const cityData = list?.data?.cityData?.map((obj: any) => ({
          label: obj?.City,
          value: obj?.LocationId,
          CountryId: obj?.CountryId,
          CountryName: obj?.CountryName,
          StateId: obj?.StateId,
          StateName: obj?.StateName
        })) ?? [];
        setDropDownList({ cityData });
      }
      else {
        setDropDownList([]);
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      // dispatch(loaderActions.end());
    }
    // dispatch(loaderActions.end());
  }

  const validation = () => {
    let status: boolean = true;
    const error: any = {}
    let regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);

    if (formValue?.NameOfCompany?.trim()?.length === 0) {
      error.NameOfCompany = "Kindly provide company name";
      status = false;
    }
    else if (datalist?.some((el: any) => el.CorporateId !== formValue?.CorporateId && el?.NameOfCompany?.trim() === formValue?.NameOfCompany?.trim())) {
      error.NameOfCompany = " This company name already exist.";
      status = false;
    }
    if (formValue.EmailId?.trim()?.length <= 0) {
      error.EmailId = "Cannot Leave blank. Please provide inputs.";
      status = false;
    }
    if (formValue?.EmailId?.trim()?.length > 0 && !isValidEmail(formValue?.EmailId)) {
      error.EmailId = "Please provide valid Email Id.";
      status = false;
    }
    if (formValue.PhoneNo?.trim()?.length <= 0) {
      error.PhoneNo = "Cannot Leave blank. Please provide inputs.";
      status = false;
    }
    if (formValue.CityId <= 0) {
      error.CityId = "Cannot Leave blank. Please provide inputs.";
      status = false;
    }
    if (formValue?.GSTNo?.trim()?.length > 0 && !regex.test(formValue?.GSTNo)) {
      error.GSTNo = "Please enter valid GST No.";
      status = false;
    }
    setFormErrors(error);
    return status;
  }

  const saveDate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validation()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let user: any = GetLocalStorage();
        formValue.UserId = user?.userMasterID
        const RpsData = await postUsersData("/midoffice/v1/insertorupdatecorporatebasicinfo", formValue);
        if (RpsData?.status) {
          setCorporateId(RpsData?.data)
          localStorage.setItem("coid", encodeURIComponent(RpsData?.data))
          getbyid(RpsData?.data);
          setIsSaved((save: any) => ({ ...save, BasicInfo: true }))
          setIsRedirect(true);
          setFormErrors({})
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        else {
          dispatch({ type: 'ALERTING', message: RpsData?.message })
        }
        dispatch(loaderActions.end());
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }

    }
  }

  const getbyid = async (id: any) => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData(`/midoffice/v1/getcorporatebasicinfobyid?corporateid=${id}`)
      if (list?.status && list?.data) {
        setFormValue({
          CorporateId: list?.data?.[0]?.CorporateId ? list?.data?.[0]?.CorporateId : 0,
          NameOfCompany: list?.data?.[0]?.NameOfCompany ? list?.data?.[0]?.NameOfCompany : '',
          PointOfContact: list?.data?.[0]?.PointOfContact ? list?.data?.[0]?.PointOfContact : '',
          POCDesignation: list?.data?.[0]?.POCDesignation ? list?.data?.[0]?.POCDesignation : '',
          EmailId: list?.data?.[0]?.EmailId ? list?.data?.[0]?.EmailId : '',
          PhoneNo: list?.data?.[0]?.PhoneNo ? list?.data?.[0]?.PhoneNo : '',
          AlternatePhoneNo: list?.data?.[0]?.AlternatePhoneNo ? list?.data?.[0]?.AlternatePhoneNo : '',
          Street: list?.data?.[0]?.Street ? list?.data?.[0]?.Street : '',
          CityId: list?.data?.[0]?.CityId ? list?.data?.[0]?.CityId : 0,
          StateId: list?.data?.[0]?.StateId ? list?.data?.[0]?.StateId : 0,
          PINCode: list?.data?.[0]?.PINCode ? list?.data?.[0]?.PINCode : '',
          CountryId: list?.data?.[0]?.CountryId ? list?.data?.[0]?.CountryId : 0,
          RegistrationNo: list?.data?.[0]?.RegistrationNo ? list?.data?.[0]?.RegistrationNo : '',
          GSTNo: list?.data?.[0]?.GSTNo ? list?.data?.[0]?.GSTNo : '',
          IsActive: list?.data?.[0]?.IsActive ? list?.data?.[0]?.IsActive : false,
          UserId: 0
        })
        setActiveId(list?.data?.[0]?.IsActive ? list?.data?.[0]?.IsActive : false);
        if (list?.data?.[0]?.StatusId) {
          UpdateStatusLocalStorage(list.data[0].StatusId);
          setCorporateStatusId && setCorporateStatusId(list.data[0].StatusId);
        }
      }
      dispatch(loaderActions.end());
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
  }

  const clearData = () => {
    setIsSaved((save: any) => ({ ...save, BasicInfo: false }))
    const id = location?.state?.id
    setFormValue({
      CorporateId: id?.CorporateId ? id?.CorporateId : 0,
      NameOfCompany: '',
      PointOfContact: '',
      POCDesignation: '',
      EmailId: '',
      PhoneNo: '',
      AlternatePhoneNo: '',
      Street: '',
      CityId: 0,
      StateId: 0,
      PINCode: '',
      CountryId: 0,
      RegistrationNo: '',
      GSTNo: '',
      IsActive: false,
      UserId: 0
    })
    setActiveId(false);
  }

  useEffect(() => {
    // getcountrystatecity();
  }, [])

  useEffect(() => {
    getcountrystatecity()
    const id: any = localStorage.getItem("coid") !== null ? (localStorage.getItem("coid")) : "";
    const retrieveIdCO: any = id ? decodeURIComponent(id) : 0;
    const COid = location.state?.id > 0 ? location.state?.id : retrieveIdCO;
    setCorporateId(COid)
    if (COid) {
      getbyid(COid)
    }
  }, [])

  useEffect(() => {
    setIsReady(true);
  }, [])

  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      saveDate()
    }
  }, [isConfirm])

  if (!isReady) {
    return (
      <Modal show={true}>
        <div className="loader">
          <Oval
            height={200}
            width={200}
            color="#122d59"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#122d59"
            strokeWidth={3}
            strokeWidthSecondary={3}


          /></div>
      </Modal>
    )
  }

  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Name Of Company' isRequired>
        <input type="text"
          id="NameOfCompany"
          className="form-control"
          name='NameOfCompany'
          value={formValue?.NameOfCompany}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('NameOfCompany', e.target?.value)}
          maxLength={100}
          placeholder='Name Of Company' />
        {formErrors?.NameOfCompany && <div className='text-danger text-start fs_14'>{formErrors?.NameOfCompany}</div>}
      </ColumnsDevider>

      <ColumnsDevider label='Point of Contact'>
        <input type="text"
          id="PointOfContact"
          className="form-control"
          name='PointOfContact'
          value={formValue?.PointOfContact}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('PointOfContact', e.target?.value)}
          maxLength={100}
          placeholder='Point of Contact' />
      </ColumnsDevider>

      <ColumnsDevider label='POC Designation'>
        <input type="text"
          id="POCDesignation"
          className="form-control"
          name='POCDesignation'
          value={formValue?.POCDesignation}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('POCDesignation', e.target?.value)}
          maxLength={100}
          placeholder='POC Designation' />
      </ColumnsDevider>

      <ColumnsDevider label='Email Id' isRequired>
        <input type="text"
          id="EmailId"
          className="form-control"
          name='EmailId'
          value={formValue?.EmailId}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('EmailId', e.target?.value)}
          maxLength={150}
          placeholder='Email Id' />
        {formErrors?.EmailId && <div className='text-danger text-start fs_14'>{formErrors?.EmailId}</div>}
      </ColumnsDevider>

      <ColumnsDevider label='Phone No.' isRequired>
        <input type="text"
          id="PhoneNo"
          className="form-control"
          name='PhoneNo'
          value={formValue?.PhoneNo}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('PhoneNo', onlyNumeric(e.target?.value))}
          maxLength={10}
          placeholder='Phone No.' />
        {formErrors?.PhoneNo && <div className='text-danger text-start fs_14'>{formErrors?.PhoneNo}</div>}
      </ColumnsDevider>

      <ColumnsDevider label='Alternate Phone No.'>
        <input type="text"
          id="AlternatePhoneNo"
          className="form-control"
          name='AlternatePhoneNo'
          value={formValue?.AlternatePhoneNo}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('AlternatePhoneNo', onlyNumeric(e.target?.value))}
          maxLength={13}
          placeholder='Alternate Phone No.' />
      </ColumnsDevider>

      {
        !domainWiseDisable.isExternalUser &&
        <ColumnsDevider label='Active'>
          <Switch
            onChange={handleisActive}
            checked={activeId}
            className="react-switch"
            disabled={location?.state?.disabled ? true : false}
          />
          <ConfirmationModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            noconfirm={() => handleConfirmation(false)}
            yesconfirm={() => handleConfirmation(true)}
          />
        </ColumnsDevider>
      }

      <div className='mt-3'><h4>Company Address</h4></div>

      <ColumnsDevider label='Street'>
        <input type="text"
          id="Street"
          className="form-control"
          name='Street'
          value={formValue?.Street}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('Street', e.target?.value)}
          maxLength={150}
          placeholder='Street' />
      </ColumnsDevider>

      <ColumnsDevider label='City' isRequired>
        <Select
          id='CityId'
          name='CityId'
          className='dropdown select_dropdown custom_class'
          options={dropdownList?.cityData}
          value={dropdownList?.cityData?.filter((fil: any) => formValue?.CityId === fil?.value)}
          isSearchable={true}
          isClearable
          closeMenuOnSelect={true}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          placeholder='Select'
          onChange={(e: any) => onChange('CityId', e)}
        />
        {formErrors?.CityId && <div className='text-danger text-start fs_14'>{formErrors?.CityId}</div>}
      </ColumnsDevider>

      <ColumnsDevider label='State'>
        <Select
          id='CityId'
          name='CityId'
          className='dropdown select_dropdown custom_class'
          value={dropdownList?.cityData?.map((el: any) => ({
            label: el.StateName,
            value: el.value
          }))?.filter((fil: any) => formValue?.CityId === fil?.value)}
          isSearchable={true}
          closeMenuOnSelect={true}
          placeholder='Select'
          isDisabled
        />
      </ColumnsDevider>

      <ColumnsDevider label='Pin Code'>
        <input type="text"
          id="PINCode"
          className="form-control"
          name='PINCode'
          value={formValue?.PINCode}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('PINCode', onlyNumeric(e.target?.value))}
          maxLength={6}
          placeholder='Pin Code' />
      </ColumnsDevider>

      <ColumnsDevider label='Country'>
        <Select
          id='CityId'
          name='CityId'
          className='dropdown select_dropdown custom_class'
          value={dropdownList?.cityData?.map((el: any) => ({
            label: el.CountryName,
            value: el.value
          }))?.filter((fil: any) => formValue?.CityId === fil?.value)}
          isSearchable={true}
          closeMenuOnSelect={true}
          placeholder='Select'
          isDisabled
        />
      </ColumnsDevider>

      <ColumnsDevider label='Registration No.'>
        <input type="text"
          id="RegistrationNo"
          className="form-control"
          name='RegistrationNo'
          value={formValue?.RegistrationNo}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('RegistrationNo', alphaNumeric(e.target?.value))}
          maxLength={150}
          placeholder='Registration No.' />
      </ColumnsDevider>

      <ColumnsDevider label='GST No.'>
        <input type="text"
          id="GSTNo"
          className="form-control"
          name='GSTNo'
          value={formValue?.GSTNo}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          onChange={(e: any) => onChange('GSTNo', alphaNumeric(e.target?.value))}
          maxLength={15}
          placeholder='GST No.' />
        {formErrors?.GSTNo && <div className='text-danger text-start fs_14'>{formErrors?.GSTNo}</div>}
      </ColumnsDevider>


      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={location?.state?.disabled || editcleardisabled || domainWiseDisable?.isExternalUser} onClick={() => saveDate()} id="btnAdd">{domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.viewtype === 'Update' ? 'Update' : 'Save')}</button>
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={editcleardisabled || location?.state?.disabled || domainWiseDisable?.isExternalUser} onClick={() => clearData()} id="btnAdd">Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" onClick={() => navigate('/corporate-management')} id="btnClear" disabled={domainWiseDisable?.isOnBording === 1}>Back</button>
      </div>
    </div>
  )
}

export default CorporateBasicInfo